<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择转赠状态" size="small">
                        <el-option label="不限制转赠状态" value=""></el-option>
                        <el-option label="仅看转赠中的" :value="0"></el-option>
                        <el-option label="仅看转赠成功的" :value="1"></el-option>
                        <el-option label="仅看转赠失败的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.transferSn" placeholder="请输入转赠流水号" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.contractName" placeholder="请输入合约名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="转赠人ID" :value="1"></el-option>
                            <el-option label="转赠人昵称" :value="2"></el-option>
                            <el-option label="转赠人手机号" :value="3"></el-option>
                            <el-option label="受赠人ID" :value="4"></el-option>
                            <el-option label="受赠人昵称" :value="5"></el-option>
                            <el-option label="受赠人手机号" :value="6"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="转赠时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="transferSn" label="转赠流水号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="转赠状态" min-width="90">
                    <template slot-scope="scope">{{status[scope.row.status]}}</template>
                </el-table-column>
                <el-table-column label="转赠人">
                    <el-table-column prop="fromUserId" label="ID" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="fromUserName" label="昵称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="fromUserTelephone" label="手机号" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="受赠人">
                    <el-table-column prop="toUserId" label="ID" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="toUserName" label="昵称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="toUserTelephone" label="手机号" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column prop="contractName" label="合约名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.contractId" :href="`/nftManage/contract/edit/${scope.row.contractId}`" type="primary" class="ellipsis">
                            {{scope.row.contractName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="presentTime" label="转赠时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/nft/afreshPresent') && scope.row.status == 2"
                            type="text"
                            size="small"
                            @click="afreshPresent(scope.row)"
                            >重新转赠</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    endTime:"",//	结束时间
    startTime:"",//	开始时间
    id:"",//	nftId
    contractName:"", //合约名称	
    searchType: 1, //搜索条件类型 1：转赠人ID 2：转赠人昵称 3：转赠人手机号 4：受赠人ID 5：受赠人昵称 6：受赠人手机号
    searchValue: "", //搜索值	
    transferSn:"",//	流水号
    timeType: 1,
    status: "", //转赠状态 不限制传空  0:转赠中 1:转赠成功 2:转赠失败
}
export default {
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
                timeType: parseInt(this.$route.query.timeType || 1),
                id: this.$route.query.id || '',
                contractName: this.$route.query.contractName || '',
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                transferSn: this.$route.query.transferSn || '',
                status: parseInt(this.$route.query.status) || "",
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
        }
    },
    computed:{
        status(){
            return{
                0:'转赠中', 1:'转赠成功', 2:'转赠失败'
            }
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/nft/presentList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //重新转赠
        afreshPresent(item){
            const confirmMsg = `确定要重新转赠吗？`
            this.$confirm(confirmMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.$request({
                    url: "/nft/afreshPresent",
                    method: "POST",
                    params: {
                        recordId: item.id,
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => {});
        }
    }
}
</script>
<style lang="scss" scoped>

</style>